import React, { useRef } from 'react';

import { useClickOutside } from '../../../../../hooks';

import { TAB_TYPE, TAB_TYPE_ICON, TAB_TYPE_LABEL } from '../../../../../constants/playbooks';

import { SvgIcon } from '../../../../../design-system';
import classNames from 'classnames';
import AlignLeftIcon from '../../../../../design-system/Icons/AlignLeftIcon';

const TAB_TYPES = [TAB_TYPE.overview, TAB_TYPE.form, TAB_TYPE.prompt];

const TabTypesSelector = ({ handleSelect, positioned, onClose: _onClose }) => {
    const selectorRef = useRef(null);

    const onClose = (e) => {
        e?.preventDefault();
        e?.stopPropagation();

        _onClose();
    };

    useClickOutside(selectorRef, onClose);

    const handleOptionClick = (type) => {
        handleSelect(type);
        onClose();
    };

    const className = classNames(
        'w-[237px] rounded-2.5 p-5 flex flex-col gap-5 bg-neutral-400 absolute z-20',
        positioned === 'up' ? 'right-0 bottom-[30px]' : 'right-3 top-[28px]'
    );

    return (
        <div ref={selectorRef} className={className}>
            <div>
                <p className="font-body text-body-regular-xs text-neutral-200 uppercase mb-4">
                    Tab Types
                </p>

                <ul className="flex flex-col gap-2">
                    {TAB_TYPES.map((type) => (
                        <li key={type}>
                            <button
                                type="button"
                                className="flex items-center gap-3 w-full py-1"
                                onClick={() => handleOptionClick(type)}
                            >
                                <SvgIcon
                                    icon={TAB_TYPE_ICON[type] || AlignLeftIcon}
                                    color="#FFFFFF"
                                    size="large"
                                />
                                <p className="font-body text-body-regular-s text-white">
                                    {TAB_TYPE_LABEL[type]}
                                </p>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TabTypesSelector;
